export default __webpack_public_path__ + "static/media/faq_arrow_up.bba0a43a.svg";